import Component from 'navigation/component/Component';
import VirtualPageManager from 'navigation/page-manager/VirtualPageManager';
import MainPage from 'navigation/pages/MainPage';
import { State } from 'helpers/state';
import modulesMap from 'core/modulesMap';
import scroll from 'core/scroll';
import InternalPage from 'navigation/pages/InternalPage';
import { defer } from 'lodash-es';
class InternalRouter extends MainPage {
    getModulesMap() {
        return {
            footer: modulesMap.footer,
            facets: modulesMap.facets
        };
    }
    getDefaultPageClass() {
        return InternalPage;
    }
    getPageSelector() {
        return '.internal-page';
    }
    bindModules() {
        Component.prototype.bindModules.call(this);
        if (!this.modules.content)
            this.modules.content = this.initContentRouter();
        this.pageManager = this.modules.content;
        defer(() => this.bindEvents(true));
    }
    initContentRouter() {
        const store = new State(null);
        return new VirtualPageManager(store, this.refs.internalRouter, this.getPageSelector(), this.getDefaultPageClass(), { pageManager: this.pageManager, parent: this });
    }
    shouldRouteInternally(el, pathName) {
        return true;
    }
    async scrollToTop() {
        if (document.scrollingElement)
            await scroll.scrollTo(0);
    }
    async internalRouting(pathName, xhr, requestOptions) {
        await this.scrollToTop();
        this.modules.content.forceRouteUpdate(pathName, xhr, requestOptions);
    }
}
export default InternalRouter;
